import React, { useEffect, useState } from "react";
import { GraphQLClient } from "graphql-request";
import { gql } from "graphql-request";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

const NewsScreen = () => {
  const [sort, setSort] = useState("date_DESC");
  const [filter, setFilter] = useState({});
  const [year, setYear] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [newsPosts1, setNewsPosts1] = useState([]);
  const [newsPosts2, setNewsPosts2] = useState([]);
  const hygraph = new GraphQLClient(
    "https://api-ap-south-1.hygraph.com/v2/clgvvde560w6e01uia29ncem5/master"
  );

  const QUERY1 = gql`
    {
      posts(orderBy: date_DESC) {
        id
        title
        link
        date
        newsCategory
        excerpt
        coverImage {
          url
        }
      }
    }
  `;
  const QUERY2 = gql`
    query GetPosts($where: PostWhereInput, $orderBy: PostOrderByInput) {
      posts(where: $where, orderBy: $orderBy) {
        id
        title
        link
        date
        newsCategory
        excerpt
        coverImage {
          url
        }
      }
    }
  `;
  useEffect(() => {
    const getBlogs = async () => {
      const { posts } = await hygraph.request(QUERY2, {
        where: filter,
        orderBy: sort || "date_DESC",
      });
      setNewsPosts2(posts);
    };
    getBlogs();
  }, [sort, filter]);

  useEffect(() => {
    const getBlogs = async () => {
      const { posts } = await hygraph.request(QUERY1);
      setNewsPosts1(posts);
    };
    getBlogs();
  }, []);

  const categoryMapping = {
    all: "All",
    pressRelease: "Press Release",
    brand: "Brand",
    founders: "Founders",
    reviews: "Reviews",
  };

  const [currentCategory, setCurrentCategory] = useState("all");

  return (
    <>
      <>
        <Navbar />
        <div className="container mt-lg-5 mt-4">
          <h1 className="pb-3 fw-bold text-center  mt-2 pt-lg-2">NEWS</h1>
          <hr />
          {newsPosts1 && newsPosts1[0] && (
            <div className="py-5">
              <a
                target="_blank"
                rel="noreferrer"
                href={newsPosts1[0].link}
                className="text-decoration-none text-dark"
              >
                <div
                  className="d-flex flex-column flex-lg-row nowrap blog-div"
                  style={{ gap: "2em" }}
                >
                  <div>
                    <img
                      src={newsPosts1[0]?.coverImage?.url}
                      className="img-fluid"
                      alt="Blog Cover"
                    />
                  </div>
                  <div>
                    <h2
                      className="mb-3 blog-heading"
                      style={{ fontFamily: "Metropolis-bold" }}
                    >
                      {newsPosts1[0]?.title}
                    </h2>
                    <div className="d-flex justify-content-between mb-4">
                      {newsPosts1[0]?.newsCategory && (
                        <p
                          style={{ fontSize: "0.9em" }}
                          className="text-em m-0 blog-category fw-bold blog-category"
                        >
                          {categoryMapping[newsPosts1[0].newsCategory]}
                        </p>
                      )}
                      <p
                        style={{ fontSize: "0.9em" }}
                        className="text-muted m-0"
                      >
                        <span className="pe-2 text-muted">
                          {months[new Date(newsPosts1[0].date).getMonth()]} {""}
                          {new Date(newsPosts1[0].date).getDate()},{" "}
                          {new Date(newsPosts1[0].date).getFullYear()}
                        </span>
                      </p>
                    </div>
                    <div>
                      <p className="text-muted m-0">{newsPosts1[0].excerpt}</p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          )}
          {/* desktop cards */}
          <div className="mb-5">
            <div className="d-lg-none mb-4">
              <div
                className="d-flex metropolis-medium p-2 px-3 rounded-5"
                onClick={() => setIsOpen(true)}
                style={{
                  gap: "0.3em",
                  color: "#004dac",
                  backgroundColor: "rgb(255 251 250)",
                  width: "fit-content",
                }}
              >
                <small>Sort and filter</small>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="Layer_1">
                    <path
                      id="Vector"
                      d="M11.9072 2.8131C11.822 2.63415 11.6876 2.48315 11.5197 2.37773C11.3519 2.27231 11.1575 2.21684 10.9593 2.21779H1.05316C0.855162 2.2178 0.661187 2.27368 0.493525 2.379C0.325862 2.48431 0.191316 2.6348 0.105345 2.81316C0.0193751 2.99151 -0.0145298 3.19051 0.00752664 3.38727C0.0295831 3.58404 0.106706 3.77058 0.230033 3.92548L4.18472 8.89255V17.1572C4.18472 17.267 4.21359 17.3747 4.26845 17.4697C4.3233 17.5648 4.4022 17.6437 4.49721 17.6985C4.59222 17.7534 4.7 17.7823 4.80971 17.7823C4.91943 17.7823 5.02721 17.7534 5.12222 17.6985L7.51523 16.3169C7.61024 16.262 7.68914 16.1831 7.74399 16.0881C7.79885 15.9931 7.82773 15.8853 7.82773 15.7756V8.89255L11.7824 3.92579C11.9067 3.7713 11.9844 3.58462 12.0065 3.38758C12.0286 3.19054 11.9942 2.99128 11.9072 2.8131ZM10.5491 3.46779L9.89234 4.29263H2.12011L1.46335 3.46779H10.5491ZM6.71378 8.28482C6.62569 8.39545 6.57773 8.53269 6.57773 8.67411V15.4148L5.43472 16.0747V8.67411C5.43472 8.53269 5.38675 8.39545 5.29867 8.28482L3.11538 5.54263H8.8971L6.71378 8.28482ZM11.8156 5.71185C11.8156 5.87761 11.8814 6.03658 11.9986 6.15379C12.1158 6.271 12.2748 6.33685 12.4406 6.33685H13.9093C14.0369 6.68018 14.2664 6.97627 14.5671 7.18536C14.8678 7.39445 15.2253 7.50651 15.5916 7.50651C15.9578 7.50651 16.3153 7.39445 16.616 7.18536C16.9167 6.97627 17.1462 6.68018 17.2738 6.33685H19.3746C19.5403 6.33685 19.6993 6.271 19.8165 6.15379C19.9337 6.03658 19.9996 5.87761 19.9996 5.71185C19.9996 5.54609 19.9337 5.38712 19.8165 5.26991C19.6993 5.1527 19.5403 5.08685 19.3746 5.08685H17.274C17.1464 4.7435 16.9169 4.4474 16.6162 4.23831C16.3155 4.02922 15.958 3.91715 15.5917 3.91715C15.2254 3.91715 14.868 4.02922 14.5672 4.23831C14.2665 4.4474 14.037 4.7435 13.9094 5.08685H12.4407C12.3586 5.08683 12.2773 5.10299 12.2015 5.13439C12.1256 5.16579 12.0567 5.21183 11.9987 5.26986C11.9406 5.3279 11.8946 5.39681 11.8632 5.47264C11.8317 5.54848 11.8156 5.62976 11.8156 5.71185ZM15.5917 5.16716C15.7361 5.16735 15.8745 5.22477 15.9765 5.32684C16.0786 5.42891 16.1361 5.56729 16.1363 5.71165V5.71204C16.1362 5.81976 16.1043 5.92505 16.0444 6.0146C15.9845 6.10415 15.8994 6.17393 15.7999 6.21513C15.7004 6.25633 15.5909 6.26708 15.4852 6.24605C15.3796 6.22501 15.2825 6.17311 15.2064 6.09693C15.1302 6.02075 15.0784 5.92369 15.0574 5.81804C15.0364 5.71239 15.0472 5.60288 15.0884 5.50336C15.1296 5.40384 15.1994 5.31879 15.289 5.25894C15.3786 5.1991 15.4839 5.16716 15.5916 5.16716H15.5917ZM19.3746 9.59595H13.7535C13.6259 9.2526 13.3964 8.9565 13.0957 8.7474C12.795 8.5383 12.4375 8.42623 12.0712 8.42623C11.705 8.42623 11.3475 8.5383 11.0467 8.7474C10.746 8.9565 10.5165 9.2526 10.389 9.59595H9.65816C9.4924 9.59595 9.33343 9.6618 9.21622 9.77901C9.09901 9.89622 9.03316 10.0552 9.03316 10.2209C9.03316 10.3867 9.09901 10.5457 9.21622 10.6629C9.33343 10.7801 9.4924 10.8459 9.65816 10.8459H10.3889C10.5165 11.1893 10.746 11.4854 11.0467 11.6945C11.3474 11.9036 11.7049 12.0157 12.0712 12.0157C12.4375 12.0157 12.7949 11.9036 13.0957 11.6945C13.3964 11.4854 13.6259 11.1893 13.7534 10.8459H19.3746C19.5403 10.8459 19.6993 10.7801 19.8165 10.6629C19.9337 10.5457 19.9996 10.3867 19.9996 10.2209C19.9996 10.0552 19.9337 9.89622 19.8165 9.77901C19.6993 9.6618 19.5403 9.59595 19.3746 9.59595ZM12.0712 10.7656C11.9634 10.7656 11.8581 10.7337 11.7685 10.6739C11.6789 10.614 11.6091 10.5289 11.5679 10.4294C11.5266 10.3298 11.5158 10.2203 11.5369 10.1146C11.5579 10.009 11.6098 9.91191 11.6859 9.83573C11.7621 9.75955 11.8592 9.70767 11.9649 9.68665C12.0705 9.66563 12.1801 9.67642 12.2796 9.71766C12.3791 9.75889 12.4642 9.82871 12.5241 9.9183C12.5839 10.0079 12.6159 10.1132 12.6159 10.2209C12.6157 10.3654 12.5583 10.5038 12.4561 10.6059C12.354 10.708 12.2156 10.7655 12.0712 10.7656ZM19.3746 14.105H18.6897C18.5622 13.7617 18.3326 13.4656 18.0319 13.2565C17.7312 13.0474 17.3737 12.9353 17.0074 12.9353C16.6412 12.9353 16.2837 13.0474 15.983 13.2565C15.6822 13.4656 15.4527 13.7617 15.3252 14.105H9.65816C9.4924 14.105 9.33343 14.1709 9.21622 14.2881C9.09901 14.4053 9.03316 14.5643 9.03316 14.73C9.03316 14.8958 9.09901 15.0547 9.21622 15.172C9.33343 15.2892 9.4924 15.355 9.65816 15.355H15.3252C15.4527 15.6984 15.6822 15.9945 15.983 16.2036C16.2837 16.4127 16.6412 16.5247 17.0074 16.5247C17.3737 16.5247 17.7312 16.4127 18.0319 16.2036C18.3326 15.9945 18.5622 15.6984 18.6897 15.355H19.3746C19.5403 15.355 19.6993 15.2892 19.8165 15.172C19.9337 15.0547 19.9996 14.8958 19.9996 14.73C19.9996 14.5643 19.9337 14.4053 19.8165 14.2881C19.6993 14.1709 19.5403 14.105 19.3746 14.105ZM17.0074 15.2747C16.8996 15.2747 16.7943 15.2428 16.7048 15.183C16.6152 15.1231 16.5453 15.0381 16.5041 14.9385C16.4629 14.839 16.4521 14.7295 16.4731 14.6238C16.4941 14.5182 16.5459 14.4211 16.6221 14.3449C16.6982 14.2687 16.7953 14.2168 16.9009 14.1958C17.0066 14.1747 17.1161 14.1855 17.2157 14.2267C17.3152 14.2679 17.4003 14.3377 17.4602 14.4272C17.52 14.5168 17.552 14.6221 17.5521 14.7298V14.7302C17.5518 14.8746 17.4944 15.013 17.3923 15.1151C17.2902 15.2171 17.1518 15.2746 17.0074 15.2747Z"
                      fill="#004dac"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div className="">
              <div className="row">
                <div
                  className="col-md-3 p-0 px-4 d-none d-lg-block"
                  style={{ borderRight: "1px solid grey", fontSize: "0.9em" }}
                >
                  <div className="mb-4">
                    <div className="mb-3">
                      <h3 className="metropolis-medium">Sort By</h3>
                    </div>
                    <div className="d-flex" style={{ gap: "0.7em" }}>
                      <div
                        className={`rounded-5 px-3 py-2 ${
                          sort === "date_DESC" ? "active-sort" : ""
                        }`}
                        onClick={() => {
                          setSort("date_DESC");
                        }}
                        style={{ border: "1px solid grey", cursor: "pointer" }}
                      >
                        <p className="mb-0">New to Old</p>
                      </div>
                      <div
                        className={`rounded-5 px-3 py-2 ${
                          sort === "date_ASC" ? "active-sort" : ""
                        }`}
                        onClick={() => {
                          setSort("date_ASC");
                        }}
                        style={{ border: "1px solid grey", cursor: "pointer" }}
                      >
                        <p className="mb-0">Old to New</p>
                      </div>
                    </div>
                  </div>
                  <hr></hr>
                  <div className="my-4">
                    <div className="mb-3">
                      <h3 className="metropolis-medium">Filters</h3>
                    </div>
                    <div className="d-flex flex-wrap" style={{ gap: "0.7em" }}>
                      <div
                        className={`rounded-5 px-3 py-2 ${
                          year === "2025" ? "active-filter" : ""
                        }`}
                        onClick={() => {
                          setFilter({
                            date_gte: "2025-01-01T00:00:00Z",
                            date_lte: "2025-12-31T23:59:59Z",
                          });
                          setYear("2025");
                        }}
                        style={{ border: "1px solid grey", cursor: "pointer" }}
                      >
                        <p className="mb-0">2025</p>
                      </div>
                      <div
                        className={`rounded-5 px-3 py-2 ${
                          year === "2024" ? "active-filter" : ""
                        }`}
                        onClick={() => {
                          setFilter({
                            date_gte: "2024-01-01T00:00:00Z",
                            date_lte: "2024-12-31T23:59:59Z",
                          });
                          setYear("2024");
                        }}
                        style={{ border: "1px solid grey", cursor: "pointer" }}
                      >
                        <p className="mb-0">2024</p>
                      </div>
                      <div
                        className={`rounded-5 px-3 py-2 ${
                          year === "2023" ? "active-filter" : ""
                        }`}
                        onClick={() => {
                          setFilter({
                            date_gte: "2023-01-01T00:00:00Z",
                            date_lte: "2023-12-31T23:59:59Z",
                          });
                          setYear("2023");
                        }}
                        style={{ border: "1px solid grey", cursor: "pointer" }}
                      >
                        <p className="mb-0">2023</p>
                      </div>
                      <div
                        className={`rounded-5 px-3 py-2 ${
                          year === "2022" ? "active-filter" : ""
                        }`}
                        onClick={() => {
                          setFilter({
                            date_gte: "2022-01-01T00:00:00Z",
                            date_lte: "2022-12-31T23:59:59Z",
                          });
                          setYear("2022");
                        }}
                        style={{ border: "1px solid grey", cursor: "pointer" }}
                      >
                        <p className="mb-0">2022</p>
                      </div>
                      <div
                        className={`rounded-5 px-3 py-2 ${
                          year === "2021" ? "active-filter" : ""
                        }`}
                        onClick={() => {
                          setFilter({
                            date_gte: "2021-01-01T00:00:00Z",
                            date_lte: "2021-12-31T23:59:59Z",
                          });
                          setYear("2021");
                        }}
                        style={{ border: "1px solid grey", cursor: "pointer" }}
                      >
                        <p className="mb-0">2021</p>
                      </div>
                      <div
                        className={`rounded-5 px-3 py-2 ${
                          year === "" ? "active-filter" : ""
                        }`}
                        onClick={() => {
                          setFilter({});
                          setYear("");
                        }}
                        style={{ border: "1px solid grey", cursor: "pointer" }}
                      >
                        <p className="mb-0">All Time</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-9 px-lg-5 col-12">
                  <div
                    className="d-flex mb-5 pb-2 news-categories"
                    style={{ overflowX: "auto", whiteSpace: "nowrap" }}
                  >
                    {Object.entries(categoryMapping).map(([key, value]) => (
                      <div key={value} style={{ cursor: "pointer" }}>
                        <h5
                          className={
                            key === currentCategory
                              ? "pb-2 blog-category-active"
                              : "pb-2"
                          }
                          onClick={() => setCurrentCategory(key)}
                          style={{
                            fontFamily: "Metropolis-bold",
                            fontSize: "1.1em",
                          }}
                        >
                          {value}
                        </h5>
                      </div>
                    ))}
                  </div>
                  <div className="row">
                    {" "}
                    {newsPosts2 &&
                      newsPosts2
                        .filter(
                          (post) =>
                            currentCategory === "all" ||
                            post.newsCategory === currentCategory
                        )
                        // .slice(1, newsPosts.length)
                        .map((post, i) => (
                          <div
                            key={i}
                            className="col-md-4 col-12 mb-4 blog-div"
                          >
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={post.link}
                              className="text-decoration-none text-dark"
                            >
                              <div
                                className=" rounded-3  h-100"
                                style={{ boxShadow: "1px 1px 5px lightgrey" }}
                              >
                                <div>
                                  <img
                                    src={post?.coverImage?.url}
                                    alt=""
                                    className="img-fluid rounded-2"
                                  />
                                </div>
                                <div className="p-3">
                                  <div className="d-flex justify-content-between mb-3">
                                    {post.newsCategory && (
                                      <p
                                        style={{ fontSize: "0.9em" }}
                                        className="text-em m-0 blog-category fw-bold"
                                      >
                                        {categoryMapping[post.newsCategory]}
                                      </p>
                                    )}
                                    <p
                                      style={{ fontSize: "0.9em" }}
                                      className="text-muted m-0"
                                    >
                                      <span className="pe-2 text-muted">
                                        {months[new Date(post.date).getMonth()]}{" "}
                                        {""}
                                        {new Date(post.date).getDate()},{" "}
                                        {new Date(post.date).getFullYear()}
                                      </span>
                                    </p>
                                  </div>

                                  <div className="">
                                    <h5
                                      className="mb-4 blog-heading"
                                      style={{
                                        fontFamily: "Metropolis-medium",
                                        display: "-webkit-box",
                                        maxWidth: "100%",
                                        fontSize: "1.15em",
                                        WebkitLineClamp: "3",
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {post.title}
                                    </h5>
                                    <p
                                      className="text-muted mt-2"
                                      style={{
                                        display: "-webkit-box",
                                        fontSize: "0.9em",
                                        maxWidth: "100%",
                                        WebkitLineClamp: "3",
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {post.excerpt}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                        ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Overlay */}
          {isOpen && (
            <div className="overlay" onClick={() => setIsOpen(false)}></div>
          )}

          {/* Bottom Sheet Menu */}
          <div className={`bottom-sheet ${isOpen ? "show" : ""}`}>
            {/* Close Button */}
            <button
              className="btn-close position-absolute top-0 end-0 m-3"
              onClick={() => setIsOpen(false)}
            ></button>

            {/* Content */}
            <div className="p-3">
              <div className="mb-4">
                <div className="mb-3">
                  <h5 className="metropolis-bold">Sort By</h5>
                </div>
                <div className="d-flex" style={{ gap: "0.7em" }}>
                  <div
                    className={`rounded-5 px-3 py-2 ${
                      sort === "date_DESC" ? "active-sort" : ""
                    }`}
                    onClick={() => {
                      setSort("date_DESC");
                    }}
                    style={{ border: "1px solid grey", cursor: "pointer" }}
                  >
                    <small className="mb-0">New to Old</small>
                  </div>
                  <div
                    className={`rounded-5 px-3 py-2 ${
                      sort === "date_ASC" ? "active-sort" : ""
                    }`}
                    onClick={() => {
                      setSort("date_ASC");
                    }}
                    style={{ border: "1px solid grey", cursor: "pointer" }}
                  >
                    <small className="mb-0">Old to New</small>
                  </div>
                </div>
              </div>
              <hr></hr>
              <div className="my-4">
                <div className="mb-3">
                  <h5 className="metropolis-bold">Filters</h5>
                </div>
                <div className="d-flex flex-wrap" style={{ gap: "0.7em" }}>
                  <div
                    className={`rounded-5 px-3 py-2 ${
                      year === "2025" ? "active-filter" : ""
                    }`}
                    onClick={() => {
                      setFilter({
                        date_gte: "2025-01-01T00:00:00Z",
                        date_lte: "2025-12-31T23:59:59Z",
                      });
                      setYear("2025");
                    }}
                    style={{ border: "1px solid grey", cursor: "pointer" }}
                  >
                    <small className="mb-0">2025</small>
                  </div>
                  <div
                    className={`rounded-5 px-3 py-2 ${
                      year === "2024" ? "active-filter" : ""
                    }`}
                    onClick={() => {
                      setFilter({
                        date_gte: "2024-01-01T00:00:00Z",
                        date_lte: "2024-12-31T23:59:59Z",
                      });
                      setYear("2024");
                    }}
                    style={{ border: "1px solid grey", cursor: "pointer" }}
                  >
                    <small className="mb-0">2024</small>
                  </div>
                  <div
                    className={`rounded-5 px-3 py-2 ${
                      year === "2023" ? "active-filter" : ""
                    }`}
                    onClick={() => {
                      setFilter({
                        date_gte: "2023-01-01T00:00:00Z",
                        date_lte: "2023-12-31T23:59:59Z",
                      });
                      setYear("2023");
                    }}
                    style={{ border: "1px solid grey", cursor: "pointer" }}
                  >
                    <small className="mb-0">2023</small>
                  </div>
                  <div
                    className={`rounded-5 px-3 py-2 ${
                      year === "2022" ? "active-filter" : ""
                    }`}
                    onClick={() => {
                      setFilter({
                        date_gte: "2022-01-01T00:00:00Z",
                        date_lte: "2022-12-31T23:59:59Z",
                      });
                      setYear("2022");
                    }}
                    style={{ border: "1px solid grey", cursor: "pointer" }}
                  >
                    <small className="mb-0">2022</small>
                  </div>
                  <div
                    className={`rounded-5 px-3 py-2 ${
                      year === "2021" ? "active-filter" : ""
                    }`}
                    onClick={() => {
                      setFilter({
                        date_gte: "2021-01-01T00:00:00Z",
                        date_lte: "2021-12-31T23:59:59Z",
                      });
                      setYear("2021");
                    }}
                    style={{ border: "1px solid grey", cursor: "pointer" }}
                  >
                    <small className="mb-0">2021</small>
                  </div>
                  <div
                    className={`rounded-5 px-3 py-2 ${
                      year === "" ? "active-filter" : ""
                    }`}
                    onClick={() => {
                      setFilter({});
                      setYear("");
                    }}
                    style={{ border: "1px solid grey", cursor: "pointer" }}
                  >
                    <small className="mb-0">All Time</small>
                  </div>
                </div>
              </div>
            </div>

            {/* footer */}
            <div className="p-3 d-flex justify-content-center my-3">
              <button
                type="button"
                className="btn btn-danger position-absolute bottom-0 end-40 m-4 px-3 rounded-5"
                onClick={() => setIsOpen(false)}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
        <Footer />
      </>
    </>
  );
};

export default NewsScreen;
